import React, { useCallback, useEffect, useState } from "react";
import { stockService } from "../../services/stockService";
import { useForm } from "react-hook-form";
import moment from "moment";


const StockHistoryTab = ({ stockDetailsList, formatCustomNumber, id }) => {
  const [stockDetailsListHistory, setStockDetailsListHistory] = useState([]);
      const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
  

      const searchByDate = useCallback(async () => {
    const formData = getValues();
    try {
      const response = await stockService.stockViewDetailsHistory(id, { ...formData });
      const { stock_history } = response.data;
      if (stock_history?.length) {
        setStockDetailsListHistory(stock_history);
      }else{
        setStockDetailsListHistory([]);

      }
    } catch (err) {
      console.log(err, "error");
    }
  }, [getValues, id]); // Added 'id' to dependency array as it's used inside

  useEffect(() => {
    if (id) {
      loadDetailsDataHistory();
    }
  }, [id]);

  const loadDetailsDataHistory = () => {
    stockService.stockViewDetailsHistory(id).then((response) => {
      const serverData = response.data;

      if (serverData?.stock_history?.length) {
        setStockDetailsListHistory(serverData?.stock_history);
      } else {
        setStockDetailsListHistory([]);
      }
    });
  };

  // Show loading / empty state
  if (!stockDetailsListHistory?.length) {
    return (
      <div className="py-12 text-center text-gray-500">
        No stock history available.
      </div>
    );
  }




  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-800 mb-6">Stock History Summary</h2>

           <div className="flex flex-row items-end space-x-2 mb-5">
                         <div>
                           <span className="ml-1 text-sm">From Date:</span>
                           <input
                             defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                             {...register("fr_date")}
                             className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
                             type="date"
                           />
                         </div>
                         <div>
                           <span className="ml-1 text-sm">To Date:</span>
                           <input
                             {...register("to_date")}
                             defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                             className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
                             type="date"
                           />
                         </div>
                         <div>
                           <button
                             onClick={searchByDate}
                             type="button"
                             className="text-sm text-white px-3 bg-blue-500 rounded py-2.5"
                           >
                             Search
                           </button>
                         </div>
                       </div>

      <div className="overflow-x-auto border border-gray-200 rounded-xl">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
            <tr>
              <th className="px-4 py-3 text-left">SN</th>
              <th className="px-4 py-3 text-left">Date</th>
              <th className="px-4 py-3 text-left">Transaction Type</th>
              <th className="px-4 py-3 text-left">Description</th>
              <th className="px-4 py-3 text-right">In</th>
              <th className="px-4 py-3 text-right">Out</th>
              <th className="px-4 py-3 text-right">Closing Qty</th>
            </tr>
          </thead>
          <tbody>
            {stockDetailsListHistory.map((item) => (
              <tr key={item.sn} className="border-b hover:bg-gray-50">
                <td className="px-4 py-3 font-medium">{item.sn}</td>
                <td className="px-4 py-3 text-gray-600">
                  {new Date(item.transaction_date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </td>
                <td className="px-4 py-3">
                  <span
                    className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium
                      ${
                        item.transaction_type_name === "Opening"
                          ? "bg-blue-100 text-blue-700"
                          : item.transaction_type_name === "Purchase"
                          ? "bg-green-100 text-green-700"
                          : item.transaction_type_name === "Production"
                          ? "bg-purple-100 text-purple-700"
                          : "bg-gray-100 text-gray-700"
                      }`}
                  >
                    {item.transaction_type_name}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-600">{item.description}</td>
                <td className="px-4 py-3 text-right text-emerald-600 font-medium">
                  {formatCustomNumber(item.in_quantity)}
                </td>
                <td className="px-4 py-3 text-right text-red-600 font-medium">
                  {formatCustomNumber(item.out_quantity)}
                </td>
                <td className="px-4 py-3 text-right font-semibold text-gray-900">
                  {formatCustomNumber(item.closing_qty)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="text-xs text-gray-400 mt-6 text-center">
        Showing {stockDetailsListHistory.length} transaction
        {stockDetailsListHistory.length !== 1 ? "s" : ""}
      </p>
    </div>
  );
};

export default StockHistoryTab;